/* ColdCake — global section reveal observer.
   - No JS / no IO / reduced-motion: content is visible (CSS default).
   - JS attached: above-the-fold elements get .in immediately (no flash),
     fade-in mode activates only for below-the-fold elements.
   - shopify:section:load: re-observes new .reveal elements (theme editor). */
(function () {
  if (!('IntersectionObserver' in window)) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  function isInViewport(el) {
    var r = el.getBoundingClientRect();
    var vh = window.innerHeight || document.documentElement.clientHeight;
    return r.top < vh - 40 && r.bottom > 0;
  }

  var io;

  function init() {
    var all = document.querySelectorAll('.reveal');

    // Pre-mark elements that are already in view — they don't fade, just show.
    all.forEach(function (el) {
      if (isInViewport(el)) el.classList.add('in');
    });

    // Now activate fade-in mode for the rest.
    document.documentElement.dataset.reveal = 'ready';

    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('in');
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    all.forEach(function (el) {
      if (!el.classList.contains('in')) io.observe(el);
    });
  }

  function attachNew() {
    if (!io) return;
    document.querySelectorAll('.reveal:not(.in)').forEach(function (el) { io.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // When the theme editor swaps a section, re-observe its .reveal children.
  document.addEventListener('shopify:section:load', attachNew);
})();
